import Loading from '@@/core/components/shared/Loading/Loading'
import mixins from '@@/core/mixins/mixins'
import FormModal from "@@/core/libraries/form/FormModal";
import {BTooltip, BButton, BCard, BCollapse, BModal, VBModal, BFormGroup, BFormInput, BTable, VBToggle, VBTooltip, BFormCheckbox} from "bootstrap-vue";

export default {
    name: "Havale",
    components: {
        BModal ,FormModal,Loading,BFormCheckbox,
        BTooltip,BButton, BCard, BTable, BCollapse, BFormGroup, BFormInput
    },
    directives: {
        "b-modal": VBModal,'b-toggle': VBToggle, 'b-tooltip': VBTooltip,
    },
    mixins: [mixins],
    data() {
        return {
            url: 'admin/store_transfers',
            isFilter: 0,
            allSelected: false,
            stores: [],
            btnStatus: false,
            selectedHavale: Array(100).fill(false),
            fields: [
                {
                    key: "select",
                    label: "",
                },
                {
                    key: 'index',
                    label: 'ردیف'
                },
                {
                    key: 'id',
                    label: 'شناسه'
                },
                {
                    key: 'from_store_label',
                    label: 'انبار مبدا'
                },
                {
                    key: 'to_store_label',
                    label: 'انبار مقصد'
                },
                {
                    key: 'items_count',
                    label: 'تعداد ایتم ها'
                },
                {
                    key: 'status',
                    label: 'وضعیت'
                },
                {
                    key: 'transmitter_full_name',
                    label: 'فروشنده'
                },
                {
                    key: 'created_at',
                    label: 'تاریخ ثبت'
                },
                {
                    key: 'show',
                    label: 'نمایش'
                },
            ],
            editStatus: [
                {
                    value: 'new',
                    name: 'انتظار تکمیل',
                },
                {
                    value: 'in_progress',
                    name: 'در حال پردازش',
                },
                {
                    value: 'sent',
                    name: 'ارسال شده',
                },
            ],
            statusOptions: [
                {
                    value: 'new',
                    name: 'انتظار تکمیل',
                },
                {
                    value: 'in_progress',
                    name: 'در حال پردازش',
                },
                {
                    value: 'sent',
                    name: 'ارسال شده',
                },
                {
                    value: 'rolled_back',
                    name: 'لغو شده',
                },
                {
                    value: '',
                    name: 'همه',
                },
            ],
            filter: {
                from_store_id: '',
                to_store_id: '',
                is_automatic: false,
                start_date: '',
                end_date: '',
                status: '',
            },
            havaleStatus: null,
        }
    },
    mounted() {
        this.loadStores();
        this.loadItems();
    },
    watch: {
        selectedHavale(newVal) {
            let selectedHavale = newVal.filter((item) => item != false);
            if (selectedHavale != "") {
                this.btnStatus = true;
            } else {
                this.btnStatus = false;
            }
        },
    },
    methods: {
        printVarieties() {
            let selectedHavale = this.selectedHavale.filter((item) => item != false);
            this.showModal = false;  
            const url = `/admin/multiple-print-havale?ids=${selectedHavale}`;
            window.open(url, '_blank');  
        },  
        havaleSelect(index, id) {
            if (!this.selectedHavale[index]) {
                this.$set(this.selectedHavale, index, id);
            } else {
                this.$set(this.selectedHavale, index, false);
            }
        },
         havaleSelectAll() {
      if (this.allSelected) {
        document
          .querySelectorAll("input[notselected]")
          .forEach((e) => e.click());
      } else {
        document.querySelectorAll("input[selected]").forEach((e) => e.click());
      }
    },
         async updateStatus() {
            this.disabled = true;
            let selectedHavale = this.selectedHavale.filter((item) => item != false);
            try {
                const response = await this.$axios.put("admin/store-transfers/update-statuses", {
                    status: this.havaleStatus ? this.havaleStatus.value : "",
                    ids: selectedHavale,
                });
                this.selectedHavale.forEach((order, index) => {
                if (!order) {
                    return;
                }
                this.items.data[index].status = this.havaleStatus.value;
                order = false;
                });
                document.querySelectorAll("input[selected]").forEach((e) => e.click());
                this.$root.notify(response.data.message, "success");
                this.$root.$emit("bv::hide::modal", "change-status");
            } catch (error) {
                this.$root.notify(error);
            }

            this.disabled = false;
        },
        async loadStores(){
            try {
                const response = await this.$axios.get("admin/stores");
                this.stores = response.data.data.stores;
            } catch (e) {
                this.$root.notify(e);
            } 
        },
        async filterItem(page = 1) {
            this.isFilter = 1;
            this.searchParams = {
                from_store_id: this.filter.from_store_id ? this.filter.from_store_id.id : "",
                to_store_id: this.filter.to_store_id ? this.filter.to_store_id.id : "",
                status: this.filter.status ? this.filter.status.value : '',
                is_automatic: this.filter.is_automatic,
                start_date: this.filter.start_date,
                end_date: this.filter.end_date,
            }
        },
    }
}
